export default () => ({
  initHeight(scrolling) {
    if (scrolling) {
      if (window.innerWidth < 768) {
        this.$refs.wrapper.style.height = window.innerHeight * 0.55 + "px";
      } else {
        this.$refs.wrapper.style.height = window.innerHeight * 0.7 + "px";
      }
    }
  },
});
